<template>
    <button
        :class="[
            'loadDefaultsButton',
            textColor,
            backgroundColor,
            hoverBackgroundColor,
            'btn',
        ]"
        :disabled="disabled"
    >
        <fa icon="fa-download" />
        <span class="xs:block ml-2 hidden">{{ $t(title) }}</span>
    </button>
</template>

<script setup lang="ts">
defineProps({
    title: {
        type: String,
        default: 'load_defaults',
    },
    backgroundColor: {
        type: String,
        default: 'bg-primary-additional-500',
    },
    textColor: {
        type: String,
        default: 'text-white',
    },
    hoverBackgroundColor: {
        type: String,
        default: 'hover:bg-primary-additional-600',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})
</script>
